import React from "react";
import PropTypes from "prop-types";

const Citations = ({ citations }) => {
  if (!citations || citations.length === 0) {
    return null;
  }

  return (
    <div className="citations">
      <p className="citation-title">Citations</p>
      <ul>
        {citations.map((citation) => (
          <li key={citation.id}>
            <a
              target="_blank"
              rel="noopener external"
              href={citation.uri}
              title={citation.title}
              className="citation"
            >
              {citation.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

Citations.propTypes = {
  citations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      uri: PropTypes.string,
      title: PropTypes.string
    })
  )
};

export { Citations };
